import { useState } from "react";

const cards = [
  {
    id: 1,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        width="26"
        height="26"
      >
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    ),
    title: "Our Mission",
    desc: "Empower small shop owners with affordable digital tools that bring clarity to daily operations.",
    borderSide: "top",
  },
  {
    id: 2,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        width="26"
        height="26"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: "Accuracy First",
    desc: "Every transaction is recorded precisely. No more guessing profits or losing track of stock.",
    borderSide: "bottom",
  },
  {
    id: 3,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        width="26"
        height="26"
      >
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </svg>
    ),
    title: "Data-Driven",
    desc: "Real-time reports on sales, inventory, and financial health help you make smarter decisions.",
    borderSide: "top",
  },
  {
    id: 4,
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        width="26"
        height="26"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
    title: "Built for You",
    desc: "Designed for Tanzanian shop owners who need a simple, reliable system no tech skills needed.",
    borderSide: "bottom",
  },
];

// ...existing code...
function AboutCard({ card }) {
  const [hovered, setHovered] = useState(false);
  const isBottom = card.borderSide === "bottom";

  const iconEl = (
    <div
      className={`
        absolute left-1/2 -translate-x-1/2 z-10
        w-14 h-14 rounded-full bg-blue-800 shadow-md
        flex items-center justify-center text-white
        border-4 border-white
        ${isBottom ? "-bottom-7" : "-top-7"}
      `}
    >
      {card.icon}
    </div>
  );

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`
        relative bg-white rounded-lg shadow-sm
        flex flex-col items-center text-center gap-4
        cursor-pointer transition-all duration-200 min-h-[220px]
        border border-gray-300
        ${isBottom ? "pt-9 pb-12 px-6" : "pt-12 pb-9 px-6"}
        ${
          hovered
            ? isBottom
              ? "border-b-2 border-b-blue-600"
              : "border-t-2 border-t-blue-600"
            : "border-gray-200"
        }
      `}
    >
      {!isBottom && iconEl}

      <h3 className="text-2xl font-semibold text-gray-900 m-0">{card.title}</h3>
      <p className="text-xl text-gray-900 leading-relaxed m-0">{card.desc}</p>

      {isBottom && iconEl}
    </div>
  );
}

export default function AboutSection() {
  return (
    <section className="w-full bg-gray-100 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mx-auto max-w-2xl text-center mb-16">
          <span className="mb-4 inline-block rounded-full border border-blue-500 bg-white px-4 py-1.5 text-sm font-semibold uppercase tracking-wider text-blue-800">
            ABOUT US
          </span>
          <h2 className="text-balance text-3xl font-bold text-gray-900 md:text-4xl">
            <span className="text-blue-800">Why Shop </span>
            <span className="text-orange-600">Kiganjani </span>
            <span className="font-bold">Exist</span>
          </h2>
          <p className="mt-4 text-pretty text-xl leading-relaxed text-gray-900">
            Many shop owners struggle with manual record-keeping that leads to
            inaccurate data, lost profits, and poor business visibility. Shop
            Kiganjani was created to solve these challenges once and for all
            bringing modern inventory and financial management to every duka.
          </p>
        </div>

        {/* Row 1: Cards 1, 2, 3 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {cards.slice(0, 3).map((card) => (
            <AboutCard key={card.id} card={card} />
          ))}
        </div>

        {/* Row 2: Card 4 centered */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="hidden md:block" />
          <AboutCard card={cards[3]} />
          <div className="hidden md:block" />
        </div>
      </div>
    </section>
  );
}
